module.exports = __webpack_public_path__ + "img/2024-12_commencement.75065669.jpg";